export const publishableKey =
  import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ?? ''
